const body = document.querySelector("body");
body.addEventListener("focus", event => toggleFocus(event.target), true);
body.addEventListener("blur", event => toggleFocus(event.target), true);

function toggleFocus(input) {
  const formField = input.closest(".form__field");
  if (formField) {
    formField.classList.toggle("form__field--focus");
  }
}
